import {
  FETCHING_ORGANIZATIONS_REQUEST, FETCHING_ORGANIZATIONS_SUCCEEDED,
  FETCHING_ORGANIZATIONS_FAILED, INVALIDATE_ORGANIZATIONS
} from './actionTypes.jsx';

import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const ORGANIZATION_BASE_URL = `${apiUrl}/api/2.0/organizations`;

export function fetchOrganizations(query, page, limit) {
  return function (dispatch) {
    dispatch(fetchingOrganizations());

    var params = {
      query: query,
      page: page,
      limit: limit
    }

    return axios({
      method: 'GET',
      url: ORGANIZATION_BASE_URL,
      params: params
    })

      .then(response =>
        dispatch(fetchingOrganizationsSuccedded(response.data))
      )

      .catch(error =>
        dispatch(fetchingOrganizationsFailed(error))
      )
  }
}


function fetchingOrganizations() {
  return {
    type: FETCHING_ORGANIZATIONS_REQUEST,
    payload: {}
  }
}

function fetchingOrganizationsSuccedded(json) {
  return {
    type: FETCHING_ORGANIZATIONS_SUCCEEDED,
    payload: json
  }
}


function fetchingOrganizationsFailed(error) {
  return {
    type: FETCHING_ORGANIZATIONS_FAILED,
    payload: error
  }
}

export function invalidateOrganizations() {
  return {
    type: INVALIDATE_ORGANIZATIONS,
    payload: {}
  }
}